export default "__VITE_ASSET__ptUqF3ld__"